import { Button, Checkbox, Dropdown, InputItem } from "pepsico-ds";

export default function FiltersBar({
  keywordText,
  onKeywordChange,
  brandsData,
  selectedBrand,
  onBrandChange,
  loadingBrands,
  onClearFilters,
  isAllSelected,
  onSelectAll,
  disableSelectAll,
}) {
  return (
    <div className="filter-container">
      <div className="content">
        <InputItem
          placeholder="Search by SKU"
          trailingIcon="search"
          size="medium"
          className="input-search"
          onChange={onKeywordChange}
          value={keywordText}
        />
        <Dropdown
          childList={brandsData}
          selection="single"
          selectedValue={selectedBrand}
          setSelectedValue={onBrandChange}
          size="medium"
          placeholder="Search by Brand"
          disabled={loadingBrands}
        />
      </div>
      <Button onClick={onClearFilters} variant="tertiary" size="small">
        Clear filters
      </Button>
      <Checkbox
        size="small"
        text="Select all"
        checked={isAllSelected}
        onUpdate={onSelectAll}
        disabled={disableSelectAll}
      />
    </div>
  );
}
